// store/reducers/serviceReducer.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedItem: null
};

const serviceSlice = createSlice({
    name: 'service',
    initialState,
    reducers: {
        setSelectedItem: (state, action) => {
            state.selectedItem = action.payload;
        },
        clearSelectedItem: (state) => {
            state.selectedItem = null;
        }
    }
});

export const { setSelectedItem, clearSelectedItem } = serviceSlice.actions;
export default serviceSlice.reducer;
